import React, { createContext, useContext, useState } from 'react';

type onCloseCallbackFunction = () => void;

interface ModalContextProps {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
  onClose: (onCloseCallback: onCloseCallbackFunction) => void;
}

interface ModalContextType {
  firstAccessModal: ModalContextProps
}

const ModalContext = createContext<ModalContextType>({
  firstAccessModal: {
    isModalOpen: false,
    openModal: () => {
      //
    },
    closeModal: () => {
      //
    },
    toggleModal: () => {
      //
    },
    onClose: (onCloseCallback: onCloseCallbackFunction) => {
      //
    },
  }
});

export const useFirstAccessModal = () => useContext(ModalContext);

export const FirstAccessModalProvider: React.FC = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onCloseCallback, setOnCloseCallback] = useState<onCloseCallbackFunction>(() => ({}));

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => {
    setIsModalOpen(false);

    if(onCloseCallback) {
      onCloseCallback();
    }
  };

  const onClose = (callback: onCloseCallbackFunction) => {
    setOnCloseCallback(() => () => callback())
  }

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <ModalContext.Provider value={{ firstAccessModal: { isModalOpen, openModal, closeModal, toggleModal, onClose } }}>
      {children}
    </ModalContext.Provider>
  );
};